<template>
  <div
    class="btn-row"
    :class="type"
    v-if="isShow"
  >
    <button
      class="btn"
      v-if="statusCode ==='TO_BE_PAY'"
      @click="setOrderActionInfo({type: 'cancel'})"
    >
      取消订单
    </button>
    <button
      class="btn confirm"
      v-if="statusCode ==='TO_BE_PAY'"
      @click="getPayWay"
    >
      重新支付
    </button>
    <button
      class="btn confirm"
      v-if="statusCode ==='SHIPPING'"
      @click="express(index)"
    >
      查看物流
    </button>
    <button
      class="btn confirm"
      v-if="statusCode ==='CLOSE'"
      @click="setOrderActionInfo({type: 'del'})"
    >
      删除订单
    </button>
  </div>
</template>

<script>
  import {setSessionCache} from '../utils/'

  export default {
    name: 'orderButton',
    props: {
      type: { // 是不是商品详情
        type: String
        , default: ''
      }
      , statusCode: { // 订单状态
        type: String
        , default: ''
      }
      , orderNo: { // 订单ID
        type: String
        , default: ''
      }
      , expNo: { // 快递单号
        type: String
        , default: ''
      }
      , expCompName: { // 快递名字
        type: String
        , default: ''
      }
      , index: { // 如果是列表传过来的标识是那个列在操作
        type: Number
        , default: 0
      }
    },
    computed: {
      isShow() {
        return this.statusCode === 'TO_BE_PAY' || this.statusCode === 'CLOSE' || this.statusCode === 'SHIPPING'
      }
    },
    data() {
      return {}
    },
    methods: {
      // 设置order弹窗
      setOrderActionInfo({type}) {
        this.$emit('setOrderActionInfo', {type, index: this.index})
      }
      // 二次支付
      , getPayWay() {
        if (this.orderNo) {
          this.$spinner.open('获取支付方式...')
          this.$store.dispatch('getPayMethods', {
            orderNo: this.orderNo
          })
            .then(() => {
              this.setOrderActionInfo({type: 'send-pay-prompt'})
            })
            .catch(() => {
              this.$toast('获取支付方式失败')
            })
            .finally(() => {
              this.$spinner.close()
            })
        }
      },
      // 查看快递信息
      express() {
        if (this.expNo && this.expCompName) {
          setSessionCache('expressInfo', {
            expCompName: this.expCompName
            , expNo: this.expNo
          })
          this.$router.push({name: 'express'})
        }
      },
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/common.scss";

  .btn-row {
    text-align: right;
    border-top: solid 1PX #f0f0f0; /* no */
    padding-top: 27px;
    .btn {
      width: 210px;
      height: 72px;
      background-color: #ffffff;
      border-radius: 36px;
      border: solid 2px #ffd012;
      font-size: 36px;
      color: #f0af00;
      margin-left: 31px;
      &.confirm {
        color: #000000;
        @extend %btnsColor;
      }
    }
    &.detail {
      border: none;
      padding: 20px 36px 19px;
      background-color: #fff;
      .btn {
        width: 340px;
        height: 115px;
        border-radius: 57px;
        font-size: 42px;
        margin-left: 19px;
      }
    }
  }
</style>